import "./ErrorMessage.css";
import React from "react";

const ErrorMessage = ({
  style = null,
  className = null,
  component = "p",
  children,
}) => {
  const props = {
    style,
    className: [className, "ErrorMessage"].filter((c) => !!c).join(" "),
    children,
  };

  switch (component) {
    case "p":
      return <p {...props} />;
    case "span":
      return <span {...props} />;
    default:
      throw new Error(`Unrecognized component "${component}"`);
  }
};

export default ErrorMessage;
